import { CssBaseline, ThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import type { ReactNode } from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { store } from '@/app/store';
import { dayjs } from '@/shared/lib/dayjs';
import { theme } from '@/theme';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Every app-wide provider, in one place and in a deliberate order.
 *
 * `enableCssLayer` is the important one: it makes MUI emit into `@layer mui`,
 * which src/styles/index.css ranks below Tailwind's utilities. Remove it and
 * every Tailwind class silently loses to MUI's component styles.
 */
export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <ReduxProvider store={store}>
      <StyledEngineProvider enableCssLayer>
        <ThemeProvider theme={theme}>
          <CssBaseline enableColorScheme />
          <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
            {children}
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </ReduxProvider>
  );
};
